import { useContext } from 'react';
import { StoresContext } from '../../../App';

const features = {
    '': 'Все',
    Special: 'Специализированный магазин',
    DIY: 'DIY',
    WebStore: 'Интернет магазин',
    Wholesale: 'Оптовые продажи',
    PanelAssembly: 'Сборщик',
};

export default function FeatureFilters() {
    const { featureFilters, setFeatureFilters } = useContext(StoresContext);
    const selectedFeatures = new Set(featureFilters.map((f) => f.code));
    const onFeatureClick = (code: string) => {
        if (!code) {
            setFeatureFilters([]);
            return;
        }
        const newFilters = featureFilters.slice();
        const selectedIdx = newFilters.findIndex((f) => f.code === code);
        if (selectedIdx !== -1) {
            newFilters.splice(selectedIdx, 1);
        } else {
            newFilters.push({ code, value: null });
        }
        setFeatureFilters(newFilters);
    };
    return (
        <ul className="tabs__list tabs__list--shops">
            {Object.entries(features).map(([code, name]) => (
                <li key={code} className="tabs__item">
                    <button
                        className={
                            'tabs__btn btn' +
                            (selectedFeatures.has(code) || (!selectedFeatures.size && !code)
                                ? ' tabs__btn--active'
                                : '')
                        }
                        type="button"
                        onClick={() => onFeatureClick(code)}
                    >
                        {name}
                    </button>
                </li>
            ))}
        </ul>
    );
}
